import React from "react";
import {
  BellIcon,
  CalendarDaysIcon,
  ChatBubbleLeftRightIcon,
  DocumentArrowUpIcon,
  EnvelopeIcon,
  FolderOpenIcon,
  HomeIcon,
  MegaphoneIcon,
  QueueListIcon,
  RectangleStackIcon,
  RocketLaunchIcon,
  ScaleIcon,
} from "@heroicons/react/24/outline";
import { UserGroupIcon } from "@heroicons/react/20/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";

export const SupportAgentIcon = ({ className }) => (
  <FontAwesomeIcon icon={faHeadset} className={className} />
);

export const createNavigationSections = (user = {}, count = 0) => {
  const isAdmin = Number(user?.role) === 1;
  const isPatient = Number(user?.role) === 2;
  const isMainAdmin = isAdmin && Number(user?.hoofd_admin) === 1;
  const releaseNotesItem = {
    name: "Release nota",
    href: "/release-notes",
    icon: MegaphoneIcon,
    current: false,
    spacedBefore: isPatient || isMainAdmin,
  };

  const mainItems = [
    { name: "Dashboard", href: "/dashboard", icon: HomeIcon, current: true },
    {
      name: isAdmin ? "Patienten Dagboek" : "Mijn DagBoek",
      href: "/eetdagboek",
      icon: ScaleIcon,
      current: false,
    },
    {
      name: isAdmin ? "Patienten Vragenlijsten" : "Mijn Vragenlijsten",
      href: "/healthforms",
      icon: QueueListIcon,
      current: false,
    },
    {
      name: isAdmin ? "Afspraken" : "Mijn Afspraken",
      href: "/planning",
      icon: CalendarDaysIcon,
      current: false,
    },
    {
      name: isAdmin ? "Berichten" : "Mijn Berichten",
      href: "/mailbox",
      icon: ChatBubbleLeftRightIcon,
      current: false,
      count,
    },
    {
      name: isAdmin ? "Patienten Documenten" : "Mijn Documenten",
      href: "/documents",
      icon: FolderOpenIcon,
      current: false,
      children: [
        {
          name: isPatient ? "Specialisten Adviezen" : "Patienten Adviezen",
          href: "/documents/advies",
          icon: BellIcon,
          current: false,
        },
        {
          name: isPatient
            ? "Mealplans/ Voedingsmiddelentabel/ Recepten"
            : "Patienten Mealplans/ Voedingsmiddelentabel/ Recepten",
          href: "/documents/plans",
          icon: RectangleStackIcon,
          current: false,
        },
        {
          name: isPatient ? "Mijn Uploads" : "Patienten Opgeladen Documenten",
          href: "/documents/uploads",
          icon: DocumentArrowUpIcon,
          current: false,
        },
      ],
    },
    {
      name: isAdmin ? "Patienten Evoluties" : "Mijn Vooruitgang",
      href: "/evolution",
      icon: RocketLaunchIcon,
      current: false,
    },
    ...(isPatient
      ? [
          {
            name: "Specialisten",
            href: "/admins",
            icon: UserGroupIcon,
            current: false,
          },
          releaseNotesItem,
        ]
      : []),
    ...(isMainAdmin
      ? [
          {
            name: "Gebruikers",
            href: "/users",
            icon: UserGroupIcon,
            current: false,
          },
          releaseNotesItem,
        ]
      : []),
    ...(isAdmin && !isMainAdmin ? [releaseNotesItem] : []),
  ];

  const serviceItems = [
    ...(isAdmin
      ? [
          {
            name: "Admin Mailbox",
            href: "/adminmailbox",
            icon: EnvelopeIcon,
            current: false,
          },
        ]
      : []),
    {
      name: isAdmin ? "Support Tickets" : "Support",
      href: "/support",
      icon: SupportAgentIcon,
      current: false,
    },
  ];

  return [
    { id: "main", items: mainItems },
    { id: "service", label: "Support", items: serviceItems },
  ];
};

export const createNavigation = (user, count) =>
  createNavigationSections(user, count).flatMap((section) => section.items);
